module.exports = __webpack_public_path__ + "img/Board.d24363eb.svg";